import script from "./ErrorDownloadView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ErrorDownloadView.vue?vue&type=script&setup=true&lang=ts"

import "./ErrorDownloadView.vue?vue&type=style&index=0&id=34494382&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\iab_b\\Documents\\Dev\\OA\\woah-transfer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34494382"]])

export default __exports__